import React from 'react';

/**
 * Diyalog marka kilidi — izometrik 3 küp işareti + "Diyalog / LOJİSTİK" wordmark.
 *
 * props:
 *  - size: 'sm' | 'md' | 'lg'  (varsayılan 'md')
 *  - variant: 'dark' (koyu zemin için açık yazı) | 'light' (açık zemin için lacivert yazı)
 *  - markOnly: sadece küp işareti
 *  - className: dış sarmalayıcıya ek sınıf
 */
const SIZES = {
  sm: { mark: 26, title: 'text-lg', sub: 'text-[9px] tracking-[0.34em]' },
  md: { mark: 34, title: 'text-2xl', sub: 'text-[10px] tracking-[0.36em]' },
  lg: { mark: 46, title: 'text-4xl', sub: 'text-xs tracking-[0.40em]' },
};

export default function DiyalogLogo({ size = 'md', variant = 'light', markOnly = false, className = '' }) {
  const s = SIZES[size] || SIZES.md;
  const titleColor = variant === 'dark' ? 'text-white' : 'text-ink';
  const subColor = variant === 'dark' ? 'text-brand-300' : 'text-brand-500';

  return (
    <span className={`inline-flex items-center gap-3 select-none ${className}`}>
      <img
        src="/diyalog-mark.svg"
        alt="Diyalog"
        width={s.mark}
        height={Math.round((s.mark * 56) / 64)}
        className="shrink-0 drop-shadow-sm"
        draggable={false}
      />
      {!markOnly && (
        <span className="flex flex-col justify-center leading-none">
          <span className={`font-extrabold ${s.title} ${titleColor} leading-none`}>Diyalog</span>
          <span className={`font-semibold uppercase ${s.sub} ${subColor} mt-1`}>Lojistik</span>
        </span>
      )}
    </span>
  );
}
